import axios from 'axios';
import {  isPc, DHB_API_PC, omitEmptyValue } from './utils';

const instance = axios.create({
  baseURL: /* '/', */ DHB_API_PC,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});


instance.interceptors.request.use(
  async (config) => {
    config.data = config.data || {};
    config.baseURL = DHB_API_PC;
    if(config.params){
      config.params = omitEmptyValue(config.params)  
    }
    return config;
  }
);
export const httpPc = instance
